import React from "react";

export default function FieldStoryPoints_InlineValueNotEmpty(props:any) {

    const onDeleteClick = () => {
        props.onChange(null);
    }

    // .ui5-field-dropdown-inline-editable - removed by Vic

    const classes = Classes({
        "ui5-field-with-delete-on-hover"    : !props.disabled,
        "flex-row-left-center"              : props.disabled,
    })

    return (
        <>
            <div className={classes}>
                <div className="" onClick={!props.disabled ? props.onClick : undefined}>
                    <div className="ui5-story-points s-24">{props.value}</div>
                </div>

                {!props.disabled && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>
            {props.children}
        </>
    )
}
